import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import React from 'react';
import goToAnchor from './go-to-anchor';
// this module uses two Contexts internally.
// the first Context is to provide a default consumer handler
// and to allow that default to be overridden from above
var AnchorContext = /*#__PURE__*/React.createContext({
  onAnchorClick: goToAnchor,
  targetMap: new Map()
}); // the second Context is to hold on to the bound handlers
// and provide them to consumers of this module's Context

var AnchorHandlersContext = /*#__PURE__*/React.createContext({
  onTargetRef: function onTargetRef() {},
  onAnchorClick: function onAnchorClick() {},
  getTargetRef: function getTargetRef() {
    return null;
  }
});

var AnchorContextProviderImpl = function AnchorContextProviderImpl(_ref) {
  var onAnchorClick = _ref.onAnchorClick,
      targetMap = _ref.targetMap,
      children = _ref.children;

  var getTargetRef = function getTargetRef(target) {
    return targetMap.get(target);
  };

  var handleTargetRef = function handleTargetRef(ref, target) {
    if (typeof window === 'undefined') return;
    if (!ref) return targetMap.delete(target); // don't overwrite current targets

    if (targetMap.get(target)) return; // store the target

    targetMap.set(target, ref);
  };

  var handleAnchorClick = function handleAnchorClick(_ref2, e) {
    var target = _ref2.target,
        behavior = _ref2.behavior;
    if (!onAnchorClick) return;
    var ref = targetMap === null || targetMap === void 0 ? void 0 : targetMap.get(target);
    if (!ref) return;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    onAnchorClick({
      target: target,
      elem: ref,
      behavior: behavior
    });
  }; // first re-provide the `onAnchorClick` handler to child contexts
  // then provide the handlers that used `onAnchorClick`
  // bound to this instance's ref Map()


  return /*#__PURE__*/React.createElement(AnchorContext.Provider, {
    value: {
      onAnchorClick: onAnchorClick,
      targetMap: targetMap
    }
  }, /*#__PURE__*/React.createElement(AnchorHandlersContext.Provider, {
    value: {
      onTargetRef: handleTargetRef,
      onAnchorClick: handleAnchorClick,
      getTargetRef: getTargetRef
    }
  }, children));
};
/**
 * Provides a context to [`AnchorLink`](./AnchorLink.md) and [`AnchorLinkContext`](./AnchorLinkContext.md). It's mandatory
 * to wrap this component around any uses of those components in a document.
 */


var AnchorContextProvider = function AnchorContextProvider(_ref3) {
  var onAnchorClick = _ref3.onAnchorClick,
      targetMap = _ref3.targetMap,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement(AnchorContext.Consumer, null, function (ctx) {
    return /*#__PURE__*/React.createElement(AnchorContextProviderImpl // use default `onAnchorClick` from context if prop not defined
    , {
      onAnchorClick: onAnchorClick || ctx.onAnchorClick // supply targetMap from context if present,
      ,
      targetMap: ctx.targetMap || targetMap
    }, children);
  });
};

export { AnchorContextProvider };
export default AnchorHandlersContext;